import { Button } from '@calendly/ui/components/button'
import { BodyText } from '@calendly/ui/components/typography'
import { useCallback } from 'react'

import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'
import { clearAllSpotlightsFromActivationData, isMeetingsOnboardingTourDismissed } from 'shared/constants/clear_spotlights_activation_data'

import { debugPanelActionsCss, debugPanelStatusCss } from './debugPanelStyles'

/** Panel body for clearing all known spotlight dismissals (title comes from registration). */
export const ClearAllSpotlightsDebugSection = () => {
  const { data: user, refetch: refetchUser } = useGetUserQuery(undefined)
  const [updateActivationData] = useUpdateUserActivationDataMutation()
  const meetingsTourDismissed = isMeetingsOnboardingTourDismissed(user?.activation_data)

  const clearAllSpotlights = useCallback(async () => {
    try {
      await updateActivationData(clearAllSpotlightsFromActivationData).unwrap()
    } catch {
      await refetchUser()
    }
  }, [refetchUser, updateActivationData])

  const handleClearAllSpotlights = useCallback(() => {
    clearAllSpotlights().catch(() => {})
  }, [clearAllSpotlights])

  return (
    <>
      <div className={debugPanelStatusCss}>
        <BodyText size="x-small">
          Meetings tour dismissed:
          {' '}
          {meetingsTourDismissed ? 'yes' : 'no'}
        </BodyText>
        <BodyText size="x-small">
          Reload meetings page to re-test. Use ?show_meetings_tour=1 to force-show.
        </BodyText>
      </div>
      <div className={debugPanelActionsCss}>
        <Button
          size="small"
          decoration="secondary-outline"
          onClick={handleClearAllSpotlights}
          data-testid="brand-refresh-debug-clear-all-spotlights"
        >
          Clear all spotlights
        </Button>
      </div>
    </>
  )
}
